// extracted by mini-css-extract-plugin
module.exports = {"burgerWrapper":"BurgerWrapper_burgerWrapper__2DcZc","posAbsolute":"BurgerWrapper_posAbsolute__3_CzW"};